import { Routes } from '@angular/router';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { PermissionResponse } from '../../core/base-api';
import { EigentuemerlisteComponent } from './eigentuemerliste.component';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const EigentuemerlisteRoutes: Routes = [
  {
    path: 'eigentuemeradressliste',
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.EIGENTUEMERADRESSLISTE_EXPORTIEREN]
    },
    loadChildren: () => routes
  }
];

const routes: Routes = [
  {
    path: '',
    component: EigentuemerlisteComponent,
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.EIGENTUEMERADRESSLISTE_EXPORTIEREN]
    }
  }
];
